import { ResetPasswordForm } from "@/auth/components/ResetPasswordForm";
import { createFileRoute } from "@tanstack/react-router";
import logo from "@/assets/EcoPROFIT_Wordmark.png";
import loginImage from "@/assets/login-image.png";

export const Route = createFileRoute("/password-reset/confirm/$uid/$token")({
  component: ResetPasswordConfirm,
});

function ResetPasswordConfirm() {
  return (
    <div className="flex h-full w-full grow flex-row">
      <div className="hidden flex-1 overflow-hidden sm:block">
        <img src={loginImage} alt="login" className="h-full w-full object-cover object-center" />
      </div>
      <section className="flex flex-1 items-center justify-center sm:items-start">
        <div className="flex w-full max-w-[348px] flex-col items-center gap-8 px-4 pb-0 pt-10 sm:px-0 sm:pt-40">
          <img src={logo} alt="EcoPROFIT logo" className="h-[48px] w-[202px]" />
          <ResetPasswordForm />
        </div>
      </section>
    </div>
  );
}
// password-reset/confirm/4/cltyd6-f201d915c6fb4d0e0e6802cc3e1ed96e/
